import { Injectable } from '@angular/core';
import { AppPermission } from 'src/app/models/appEnums';

export type PayrollManagementDestination =
  'payrollApproval' | 'reimbursementApproval' | 'reimbursementTypes' | 'manualEntryReport' | 'rejectionReasons';

export interface PayrollManagementTab {
  destination: PayrollManagementDestination;
  label: string;
  route: string;
}

@Injectable({ providedIn: 'root' })
export class PayrollManagementAccessService {
  readonly orderedTabs: PayrollManagementTab[] = [
    { destination: 'payrollApproval', label: 'Payroll Approval', route: '/payroll/approval' },
    { destination: 'reimbursementApproval', label: 'Reimbursement Approval', route: '/payroll/reimbursements' },
    { destination: 'reimbursementTypes', label: 'Manage Reimbursement Types', route: '/payroll/reimbursement-types' },
    { destination: 'manualEntryReport', label: 'Manual Entry Report', route: '/payroll/manualEntries' },
    { destination: 'rejectionReasons', label: 'Rejection Reasons', route: '/payroll/rejection-reasons' }
  ];

  canAccess(destination: PayrollManagementDestination, permissionIDs: number[]): boolean {
    const permissions = permissionIDs || [];
    const canViewPayroll = permissions.includes(AppPermission.PayrollApprovalViewAll)
      || permissions.includes(AppPermission.PayrollApprovalViewMainCampus)
      || permissions.includes(AppPermission.PayrollApprovalViewAssigned);

    if (destination === 'payrollApproval' || destination === 'manualEntryReport') {
      return canViewPayroll;
    }
    if (destination === 'reimbursementApproval') {
      return permissions.includes(AppPermission.HRPortalReimbursementsHRApproval)
        || permissions.includes(AppPermission.HRPortalReimbursementsAAInitialApproval);
    }
    if (destination === 'reimbursementTypes') {
      return permissions.includes(AppPermission.HRPortalReimbursementTypesView)
        || permissions.includes(AppPermission.HRPortalReimbursementTypesEdit);
    }
    return canViewPayroll || permissions.includes(AppPermission.PayrollApprovalApprove);
  }

  accessibleTabs(permissionIDs: number[]): PayrollManagementTab[] {
    return this.orderedTabs.filter(tab => this.canAccess(tab.destination, permissionIDs));
  }

  defaultRoute(permissionIDs: number[]): string {
    return this.accessibleTabs(permissionIDs)[0]?.route || '/management';
  }
}
